import { Box, Grid, GridItem } from "@chakra-ui/layout"
import { ToggleHelpMode } from "domains/interactions";
import { AddAssetMenu, usePackContext } from ".";
import { PackActions } from "./actions";
import { useLoggedinUser, usePack, useStickyAd } from "lib/hooks";
import { useRouter } from "next/router";
import { isPreviewingPack, isReadOnly } from "lib/utils";

export const AddAssetFooter = () => {
  const { pathname } = useRouter();
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);
  const { displayAd } = useStickyAd(packId);
  const { isLoggedIn } = useLoggedinUser();

  if (isPreviewingPack(pathname) || (isReadOnly(pack) && !isLoggedIn)) {
    return null;
  }

  return (
    <Box
      position="fixed"
      zIndex={2}
      bottom="0"
      right="0"
      left="0"
      width="100%"
      pl="15px"
      pr="15px"
      height={displayAd ? [300, 265, 240, 190] : 76}
    >
      <Grid
        position="relative"
        width="100%"
        maxWidth={920}
        margin="0 auto"
        zIndex="100"
        gridTemplateColumns='auto 74px auto'
        height="100%"
      >
        <GridItem
          position="relative"
          bgColor="white"
          display="flex"
          alignItems="center"
          _before={{
            content: `' '`,
            position: 'absolute',
            left: '-2000px',
            right: 0,
            top: 0,
            bottom: 0,
            boxShadow: "1px 0px 19px rgba(0, 0, 0, 0.16)",
            backgroundColor: 'white',
          }}
        >
          <ToggleHelpMode position="absolute" top="18px" />
        </GridItem>
        <GridItem
          bgImage="/button-surrond.svg"
          height="76px"
          width="74px"
          bgPos="center center"
          bgSize="auto 76px"
          bgRepeat="no-repeat"
          zIndex="2"
          position="relative"
        >
          <Box width="100%" textAlign="center" zIndex="1">
            <AddAssetMenu />
          </Box>
        </GridItem>
        <GridItem
          position="relative"
          bgColor="white"
          display="flex"
          justifyContent="end"
          alignItems="center"
          _before={{
            content: `' '`,
            position: 'absolute',
            right: '-2000px',
            left: 0,
            top: 0,
            bottom: 0,
            boxShadow: "1px 0px 19px rgba(0, 0, 0, 0.16)",
            backgroundColor: 'white',
          }}
        >
          <Box position="absolute" right="0" top="18px">
            <PackActions />
          </Box>
        </GridItem>
      </Grid>
    </Box>
  );
}
